import type { FastifyInstance } from 'fastify'
import { db, realtimeDb } from '../../core/database/firebase.js'
import { LiveService } from './live.service.js'
import { LiveController } from './live.controller.js'
import { LiveNavigationService } from './liveNavigation.service.js'
import { LiveNavigationController } from './liveNavigation.controller.js'
import { liveRoutes } from './live.routes.js'

export default async function liveModule(app: FastifyInstance) {
  const service = new LiveService(db)
  const controller = new LiveController(service)
  
  const navService = new LiveNavigationService(realtimeDb, db)
  const navController = new LiveNavigationController(navService)
  
  await liveRoutes(app, controller, navController)
}
